var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMotorSports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Sports-Car-Convertible--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Sports Car Convertible Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11h4a0.5 0.5 0 0 0 0.5 -0.5 2.5 2.5 0 0 0 -5 0 0.5 0.5 0 0 0 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 17a2 2 0 1 0 4 0 2 2 0 1 0 -4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25 17a2 2 0 1 0 4 0 2 2 0 1 0 -4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.18 7.24 0.89 -0.24a1 1 0 1 0 -0.64 -1.9l-4.5 1.5a1 1 0 0 0 -0.63 1.27 1 1 0 0 0 0.95 0.68c0.08 0 0.78 -0.22 1.1 -0.31 0.09 0 0.15 0 0.15 0.09l0 1.88a0.35 0.35 0 0 1 -0.38 0.34h-0.62a0.63 0.63 0 0 1 -0.39 -0.27c-0.87 -1.7 -3.17 -2.38 -4.27 -2.62a0.49 0.49 0 0 0 -0.6 0.49v2.4a2 2 0 0 1 -2 2H4.57A4 4 0 0 0 1 14.71l-0.72 1.43a0.23 0.23 0 0 0 0 0.24 0.22 0.22 0 0 0 0.21 0.12H3.6a0.25 0.25 0 0 0 0.24 -0.19 3 3 0 0 1 5.82 0 0.25 0.25 0 0 0 0.24 0.19h7.2a0.25 0.25 0 0 0 0.24 -0.19 3 3 0 0 1 5.86 0.19h0.05v-5a1 1 0 0 0 -1 -1 0.21 0.21 0 0 1 -0.24 -0.22l0 -2.75c-0.01 -0.14 0.17 -0.29 0.17 -0.29Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMotorSports);
export default ForwardRef;